<template>
  <VLayout>
    <b-row>
      <b-col xs="12" sm="3" class="d-none d-sm-block">
        <CategorySelector
          :categories="categories"
          :selectedCategory="selectedCategory"
        />
        <BrandSelector
          :source="brandDataSource"
          :selectedBrand="brandUuid"
          :categoryUuid="categoryUuid"
          :groupedCategoryUuid="groupedCategory"
          class="mt-5"
        />
      </b-col>
      <b-col xs="12" sm="9" class="mt-4 mt-md-0">
        <ProductsViewer
          :brandUuid="brandUuid"
          :source="dataSource"
          :categoryUuid="categoryUuid"
          :groupedCategoryUuid="groupedCategory"
          noneOrderBy="default_description"
        />
      </b-col>
    </b-row>
  </VLayout>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import VLayout from "@/layouts/Default";
import ProductsViewer from "@/components/ProductsViewer";
import BrandSelector from "@/components/BrandSelector";
import CategorySelector from "@/components/CategorySelector";

export default {
  components: {
    VLayout,
    ProductsViewer,
    BrandSelector,
    CategorySelector,
  },
  props: {
    categoryUuid: String,
    groupedCategory: String,
    brandUuid: String,
  },
  computed: {
    ...mapGetters("drugs", ["getCategoryByUuid"]),
    ...mapState({
      groupedCategories: state => state.drugs.groupedCategories,
    }),
    dataSource: function() {
      return "drugs/REQUEST_PHDRUGS";
    },
    brandDataSource() {
      return "drugs/REQUEST_PHDRUGS_BRANDS";
    },
    categories() {
      var group = this.groupedCategories.find(
        gcat => gcat.uuid === this.groupedCategory
      );
      if (group) {
        let categories = [];
        group.categories.forEach(element => {
          let category = this.getCategoryByUuid(element.uuid);
          if (category) {
            categories.push(category);
          }
        });
        return categories;
      }
      return undefined;
      // return group && group.categories;
    },
    selectedCategory() {
      if (this.categoryUuid) {
        return this.getCategoryByUuid(this.categoryUuid);
      }
      return undefined;
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        grouped_categories: {
          title: "Categories",
          results: "Results by ",
        },
      },
    },
  },
};
</script>


<style>
</style>
